// Bundled with the fallback so it still works when CMS or i18n loading fails.
const messages = {
  en: {
    title: "Server error",
    timeoutTitle: "The server is taking too long to respond",
    description: "We couldn't load this page. Please try again.",
    recovery:
      "We'll check again automatically and reload the page when it's available.",
    retry: "Try again",
    home: "Home page",
  },
  et: {
    title: "Serveri viga",
    timeoutTitle: "Serveri vastus võtab liiga kaua aega",
    description: "Lehte ei õnnestunud laadida. Palun proovi uuesti.",
    recovery:
      "Kontrollime automaatselt uuesti ja laadime lehe, kui see on saadaval.",
    retry: "Proovi uuesti",
    home: "Avaleht",
  },
  ru: {
    title: "Ошибка сервера",
    timeoutTitle: "Сервер отвечает слишком долго",
    description: "Не удалось загрузить страницу. Попробуйте ещё раз.",
    recovery:
      "Мы автоматически проверим доступность страницы и загрузим её после восстановления.",
    retry: "Попробовать ещё раз",
    home: "Главная страница",
  },
  fi: {
    title: "Palvelinvirhe",
    timeoutTitle: "Palvelimen vastaus kestää liian kauan",
    description: "Sivua ei voitu ladata. Yritä uudelleen.",
    recovery:
      "Tarkistamme tilanteen automaattisesti ja lataamme sivun, kun se on saatavilla.",
    retry: "Yritä uudelleen",
    home: "Etusivu",
  },
  lv: {
    title: "Servera kļūda",
    timeoutTitle: "Servera atbilde aizņem pārāk ilgu laiku",
    description: "Neizdevās ielādēt lapu. Lūdzu, mēģiniet vēlreiz.",
    recovery:
      "Mēs automātiski pārbaudīsim lapas pieejamību un ielādēsim to, kad tā būs pieejama.",
    retry: "Mēģināt vēlreiz",
    home: "Sākumlapa",
  },
  lt: {
    title: "Serverio klaida",
    timeoutTitle: "Serveris per ilgai neatsako",
    description: "Nepavyko įkelti puslapio. Bandykite dar kartą.",
    recovery:
      "Automatiškai patikrinsime puslapio pasiekiamumą ir įkelsime jį, kai jis bus pasiekiamas.",
    retry: "Bandyti dar kartą",
    home: "Pradinis puslapis",
  },
  pl: {
    title: "Błąd serwera",
    timeoutTitle: "Serwer odpowiada zbyt długo",
    description: "Nie udało się załadować strony. Spróbuj ponownie.",
    recovery:
      "Automatycznie sprawdzimy dostępność strony i załadujemy ją, gdy będzie dostępna.",
    retry: "Spróbuj ponownie",
    home: "Strona główna",
  },
};

export function getServerErrorMessages(locale) {
  return messages[locale?.split("-")[0]] || messages.en;
}
